export default "__VITE_ASSET__d8ab1ea0__"